<template>
  <div class="table-container">
    <template v-if="canVerb(resource, 'index')">
      <actions-toolbar>
        <template #filters>
          <div class="status-filter">
            <!-- <p style="display: flex; align-items: center; gap: 5px">
              <span style="font-size: 14px; font-weight: 500">Filtri</span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1024 1024"
                width="18"
              >
                <path
                  d="M960 682.7H527.3c-9.7 0-18.2-6.6-20.7-16-16.5-64.2-74.6-112-144-112s-127.6 47.8-144 112c-2.4 9.4-10.9 16-20.7 16H64c-11.8 0-21.3 9.6-21.3 21.3h0c0 11.8 9.6 21.3 21.3 21.3h134c9.7 0 18.2 6.6 20.7 16 16.5 64.2 74.6 112 144 112s127.6-47.8 144-112c2.4-9.4 10.9-16 20.7-16h432.7c11.8 0 21.3-9.6 21.3-21.3h0c0-11.8-9.6-21.3-21.3-21.3zm-597.3 128c-58.9 0-106.6-47.8-106.6-106.7s47.7-106.6 106.6-106.6 106.6 47.8 106.6 106.7-47.7 106.6-106.6 106.6zm298.6-341.4c69.4 0 127.6-47.8 144-112 2.4-9.4 10.9-16 20.7-16h134c11.8 0 21.3-9.6 21.3-21.3h0c0-11.8-9.6-21.3-21.3-21.3H826c-9.7 0-18.2-6.6-20.7-16-16.5-64.2-74.6-112-144-112s-127.6 47.8-144 112c-2.4 9.4-10.9 16-20.7 16H64c-11.8 0-21.3 9.6-21.3 21.3h0c0 11.8 9.6 21.3 21.3 21.3h432.7c9.7 0 18.2 6.6 20.7 16 16.5 64.2 74.6 112 144 112h0zm0-256c58.9 0 106.7 47.8 106.7 106.7s-47.8 106.7-106.7 106.7S554.6 378.9 554.6 320s47.8-106.7 106.7-106.7h0z"
                ></path>
              </svg>
            </p> -->
            <!-- <pre>{{ activeFilters }}</pre> -->
            <!-- v-for="(value, name, index) in computeActiveFilters" -->
            <div class="pill-wrapper my-3">
              <span
                class="pill"
                v-for="(value, name, index) in activeFilters"
                :key="index"
                data-color="white"
              >
                <span v-b-toggle.sidebar-1 :data-filter="name"
                  ><strong>{{ sidebarFilterName(name, context) }}</strong
                  >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
                >
                <span tabindex="0">
                  <span
                    @click="resetSingleSidebarFilter(name)"
                    title="Rimuovi filtro"
                    >×</span
                  >
                </span>
              </span>
              <template v-if="countActiveFilters">
                <span
                  class="pill"
                  data-color="alert"
                  @click="resetAllFilters()"
                  title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
                >
                  <span
                    ><strong>Reset ({{ countActiveFilters }})</strong></span
                  >
                  <span><span>×</span></span>
                </span>
              </template>
            </div>
          </div>
        </template>
        <b-button-group
          v-b-toggle:sidebar-1
          :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
            countActiveFilters ? ' active' : ''
          }`"
          :title="getDefaultFilterMessage()"
        >
          <base-icon name="filters" width="23" height="23" />
          <span style="font-size: 14px; font-weight: 500">
            {{ computedFilterTitle }}
          </span>
        </b-button-group>
        <export-options
          :exportUrl="exportUrl"
          :repository="repository"
          :resource="resource"
          :tableRef="$refs[tableRef]"
          :filter="filter"
          :options="[
            // {
            //   code: 'LISTIT',
            //   label: null,
            //   formats: ['csv', 'pdf'],
            // },
            {
              code: 'EXPOINAN',
              label: null,
              formats: ['csv', 'pdf'],
            },
            {
              code: 'LISTITINCA',
              label: null,
              formats: ['csv', 'pdf'],
            },
          ]"
        ></export-options>
        <b-button
          v-if="
            $store.state.auth.settings.attributables.LISAPAY === 'Y' &&
            $store.state.auth.settings.attributables.LPAYZCH === 'Y'
          "
          class="btn btn--smaller btn--transparent"
          type="button"
          variant="secondary"
          size="sm"
          @click="customOpenSyncroModal($event.target)"
          title="Recupera da Syncro"
          >Recupera da Syncro
        </b-button>
        <b-button
          class="btn btn--create btn--smaller"
          type="button"
          variant="primary"
          size="sm"
          @click="onAdd"
          title="Crea un nuovo titolo"
          v-if="canVerb(resource, 'store')"
        >
          <base-icon name="circled_plus" width="22" height="22" />
          Crea
        </b-button>
      </actions-toolbar>
      <div class="table-container">
        <b-sidebar
          id="sidebar-1"
          :title="computedFilterTitle"
          :backdrop="true"
          width="50dvw"
          shadow
          right
          :visible="open_filter"
          :data-open="open_filter"
          @change="onSidebarFilterChange"
        >
          <template #header="{ hide }">
            <div class="inner-header">
              <div class="inner-header--create">
                <strong class="mr-auto"> Crea un nuovo titolo </strong>
                <b-button
                  class="btn btn--create btn--smaller"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAdd"
                  title="Crea un nuovo titolo"
                  :disabled="!canVerb(resource, 'store')"
                >
                  <base-icon name="circled_plus" width="16" height="16" />
                  <span>Crea</span>
                </b-button>
              </div>
              <div class="inner-header--info">
                <strong class="mr-auto">
                  {{ computedFilterTitle }}
                </strong>
                <button class="close text-dark" @click="hide">
                  <b-icon icon="x"></b-icon>
                </button>
              </div>
            </div>
          </template>
          <b-form @submit.prevent="onSearch(filterName)">
            <div class="filter">
              <div class="filter-item" data-cols="2">
                <base-datepicker
                  name="data_effetto_dal"
                  label="Data di effetto dal"
                  v-model="filter.byCalendar.from"
                />
                <base-datepicker
                  name="data_effetto_al"
                  label="Data di effetto al"
                  v-model="filter.byCalendar.to"
                />
              </div>
              <div class="filter-item">
                <b-button-group class="mb-3 relative-month-group">
                  <b-button
                    class="btn--transparent btn--x-smaller"
                    variant="primary"
                    @click="setYearRange(-1)"
                  >
                    {{ getYearLabel(-1) }}
                  </b-button>
                  <b-button
                    class="btn--transparent btn--x-smaller"
                    variant="primary"
                    @click="setYearRange(0)"
                  >
                    {{ getYearLabel(0) }}
                  </b-button>
                </b-button-group>
              </div>
              <div class="filter-item" data-cols="2">
                <base-datepicker
                  name="data_ultimo_giorno_dal"
                  label="Data ultimo giorno dal"
                  v-model="filter.byDelayUntil.from"
                />
                <base-datepicker
                  name="data_ultimo_giorno_al"
                  label="Data ultimo giorno al"
                  v-model="filter.byDelayUntil.to"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <div>
                  <base-select
                    name="Produttore"
                    label="Produttore"
                    v-model="filter.byBroker.id"
                    :options="salesmen_select"
                    :taggable="salesmen_taggable"
                    :multiple="true"
                    :closeOnSelect="false"
                    :defaultHtmlMultipleSelect="true"
                    @changeTaggable="changeTaggable"
                  >
                    <template #advanced-actions>
                      <b-button
                        :pressed.sync="myToggle"
                        variant="light"
                        class="btn--x-smaller btn--smaller btn--transparent"
                        @click="
                          myToggle ? selectAllSalesmen() : deselectAllSalesmen()
                        "
                        >{{
                          myToggle ? "Deseleziona tutti" : "Seleziona tutti"
                        }}
                      </b-button>
                      <b-button
                        :pressed.sync="myTogglePO"
                        variant="light"
                        class="btn--smaller btn--x-smaller btn--transparent"
                        @click="
                          myTogglePO
                            ? salesmenOrderByCode()
                            : salesmenOrderByName()
                        "
                        >{{
                          myTogglePO ? "Ordine per nome" : "Ordina per codice"
                        }}
                      </b-button>
                    </template>
                  </base-select>
                </div>
                <div>
                  <base-select
                    name="Compagnia"
                    label="Compagnia"
                    :options="companies"
                    v-model="filter.byInsurer.id"
                  />
                </div>
              </div>
              <div class="filter-item" data-cols="2">
                <base-select
                  name="Stato Titoli"
                  label="Stato Titoli"
                  v-model="filter.byAttribute.status_ancillary"
                  :options="titoli"
                  :taggable="true"
                  :multiple="true"
                  :closeOnSelect="false"
                />
                <base-select
                  name="tipo_titoli"
                  label="Tipo Titoli"
                  v-model="filter.byAttribute.code"
                  :options="tipo_titoli"
                  :taggable="true"
                  :multiple="true"
                  :closeOnSelect="false"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-select
                  name="risks"
                  label="Tipologie di polizze"
                  :options="risks"
                  v-model="filter.byRiskType.id"
                  :taggable="true"
                  :multiple="true"
                  :closeOnSelect="false"
                />
                <base-select
                  name="coopertaor"
                  label="Collaborazione"
                  :options="cooperators"
                  v-model="filter.byCollaborator.id"
                  :taggable="true"
                  :multiple="true"
                  :closeOnSelect="false"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-input
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="Polizza"
                  label="Polizza"
                  placeholder="Inserisci un numero polizza"
                  v-model="filter.byInsurancePolicy.number"
                />
                <base-input
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="Anagrafica"
                  label="Anagrafica"
                  placeholder="Inserisci un nominativo"
                  v-model="filter.byRegistry.title"
                  @input="onRegistryTitleInput"
                />
              </div>
              <div class="filter-item" data-type="registry-group">
                <div>
                  <b-button-toolbar>
                    <b-button-group>
                      <base-input
                        :class="{
                          'filter-item-inner-wrapped': true,
                        }"
                        name="Gruppo Anagrafico"
                        label="Gruppo Anagrafico"
                        v-model="form.inpt_label_group"
                        :readonly="true"
                      />
                      <b-button
                        class="btn-quick btn--light"
                        size="sm"
                        text="Button"
                        variant="lisaweb"
                        title="Cerca gruppo anagrafico"
                        @click="openQuickSearchGroup"
                      >
                        <!-- <b-icon icon="search"></b-icon> -->
                        <base-icon
                          name="search"
                          width="14"
                          height="14"
                        ></base-icon>
                      </b-button>
                      <b-button
                        v-if="form.inpt_label_group"
                        class="btn--light btn--alert"
                        size="sm"
                        text="Button"
                        variant="lisaweb"
                        @click="resetGroupId"
                        title="Elimina gruppo anagrafico"
                      >
                        <!-- <base-icon name="trash" width="22" height="22"></base-icon> -->
                        <base-icon
                          name="trash"
                          width="22"
                          height="22"
                        ></base-icon>
                      </b-button>
                    </b-button-group>
                  </b-button-toolbar>
                </div>
              </div>
              <quick-search-group-modal
                ref="quickSearchGroup"
                @input="handleGroupModalInput"
              ></quick-search-group-modal>
              <div class="filter-item" data-type="registry-group-info">
                <div class="details-card-wrapper" v-if="extra_group_full_info">
                  <b-card>
                    <div
                      slot="header"
                      class="d-flex justify-content-between align-items-center"
                    >
                      <p class="mb-0 d-inline-block align-middle">
                        <strong
                          >Informazioni gruppo anagrafico selezionato</strong
                        >
                      </p>
                    </div>
                    <div
                      class="custom-grid-wrapper"
                      v-html="extra_group_full_info"
                    ></div>
                  </b-card>
                </div>
              </div>
              <div class="filter-item" data-cols="3">
                <base-datepicker
                  name="effective_at"
                  label="Data di riferimento per titoli arretrati"
                  v-model="filter.byStocastico.date"
                />
                <base-select
                  name="status"
                  label="Condizione titoli"
                  v-model="filter.byStocastico.status"
                  :options="opt_status"
                  :taggable="true"
                  :multiple="true"
                  :closeOnSelect="false"
                />
                <base-input
                  name="commento_qt"
                  v-model="filter.byInsurancePayment.comment"
                  type="text"
                  label="Commento QT"
                  placeholder="Inserisci un commento"
                />
              </div>
              <div class="filter-item">
                <base-select
                  name="Upselling"
                  label="Upselling"
                  v-model="filter.byAttribute.upselling"
                  :options="upselling_options"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-select
                  name="Incassabile"
                  label="Incassabile"
                  :options="to_collect_options"
                  v-model="filter.byAttribute.to_collect"
                />
                <base-select
                  name="Consolidato"
                  label="Consolidato"
                  :options="to_collect_options"
                  v-model="filter.byAttribute.consolidated"
                />
              </div>
            </div>
            <div class="actions-filter-sidebar-wrapper">
              <b-button
                type="submit"
                variant="lisaweb"
                size="sm"
                v-b-toggle:sidebar-1
                >Cerca
              </b-button>
              <b-button
                class="btn--transparent btn-reset"
                type="button"
                size="sm"
                @click="onClearFilter(filterName)"
                >Reset
              </b-button>
            </div>
          </b-form>
        </b-sidebar>
        <!-- <button-group-table
          @csv="onExport('csv')"
          :options="{
            CSV: { enabled: true },
          }"
        ></button-group-table> -->
        <div
          class="table-wrapper"
          data-type="overflow-x"
          style="margin-left: 0 !important"
        >
          <insurance-ancillaries
            @edit="onEdit"
            @destroy="onDestroy"
            @manualFetch="manualFetch"
            :fields="fields"
            :repository="repository"
            :resource="resource"
            :performedSearch="computePerformedSearch"
            :filterCount="countActiveFilters"
            :filterOn="{
              byRelations: [
                'byTask',
                'byBroker',
                'byRegistryGroup',
                'byBookEntry',
                'byRegistry',
                'byCollaborator',
                'byInsurerParticipant',
                'byUser',
              ],
            }"
            @selezionato="onUpdateSelected"
            @spunta="onSelectAll"
            @spuntapagina="onSelectPage"
            @toglispunta="onUnselectAll"
            :loadingSpunte="isLoadingSpunte"
            :hasChecksButtonGroup="true"
            :filterName="filterName"
            :onlyActions="['edit', 'infomodal', 'destroy_manual']"
            :deletingIds="deletingIds"
            :ref="tableRef"
            @rowSelector="onAddBookEntry"
            @toggle_to_collect="onToggleToCollect"
            includeRowSelector
            sortField="delay_until"
          >
            <template #selection-actions="{ count }">
              <b-button
                type="button"
                variant="lisaweb"
                class="btn-create btn--smaller"
                :disabled="count === 0"
                @click="onSendCommunications"
                >Invia selezionati ({{ count }})
              </b-button>
            </template>
            <template #pagination-legend>
              <div class="ancillary-legend">
                <span class="ancillary-legend__item">
                  <span class="ancillary-legend__dot is-ending"></span>
                  in scadenza
                </span>
                <span class="ancillary-legend__item">
                  <span class="ancillary-legend__dot is-last-day"></span>
                  ultimo giorno
                </span>
                <span class="ancillary-legend__item">
                  <span class="ancillary-legend__dot is-expired"></span>
                  scaduti
                </span>
              </div>
            </template>
          </insurance-ancillaries>
        </div>
        <recupera-da-syncro-modal
          @fetch="forcedFetch"
          type="insurance_ancillary"
        >
        </recupera-da-syncro-modal>
      </div>
    </template>
    <div v-else class="mt-3">
      <b-icon icon="info-circle" scale="1.00"></b-icon>
      Non hai i permessi
    </div>
  </div>
</template>

<script>
import InsuranceAncillaries from "@/components/tables/InsuranceAncillaries";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/form/BaseInput";
import ExportOptions from "@/components/ExportOptions";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import RecuperaDaSyncroModal from "@/components/modals/recuperaDaSyncroModal";
import QuickSearchGroupModal from "@/components/modals/quickSearchGroup";
import { toLocaleCurrency } from "@/utils/strings";
import { toInfoData } from "@/utils/transforms";
import { toLocaleDate } from "@/utils/dates";
import { prepareFilterQueryString } from "@/utils/forms";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import SidebarFilterMixin from "../../mixins/SidebarFilterMixin";

moment.locale("it");
// import ExportsMixin from "@/mixins/ExportsMixin";

export default {
  mixins: [CustomFiltersMixin, StorageGetterMixin, SidebarFilterMixin],
  data() {
    return {
      exportUrl: null,
      filter: this.initFilter(),
      activeFilters: {},
      performedSearch: false,
      companies: [],
      isLoadingSpunte: false,
      status_policy_opt: [
        { value: "0", text: "Non perfezionata" },
        { value: "1", text: "Perfezionata" },
        { value: "2", text: "Sospesa" },
        { value: "3", text: "Sostituita" },
        { value: "10", text: "Stornata" },
        { value: "4", text: "Annullata" },
        { value: "5", text: "Scaduta" },
        { value: "6", text: "Svincolata" },
        { value: "7", text: "Abbandonata" },
        { value: "8", text: "Disdetta" },
        { value: "9", text: "Nuova viva" },
      ],
      tableRef: "InsuranceAncillariesTableRef",
      deletingIds: [],
      filterName: "filterInsuranceAncillaries",
      resource: "insurance_ancillaries",
      context: "insurance_ancillaries",
      repository: "insurance_ancillary",
      userId: this.$store.state.auth.user.id,
      registry_data: null,
      insurance_policy_data: null,
      group_data: null,
      extra_group_full_info: null,
      risks: [],
      notes: [],
      form: {
        inpt_label_policy: "",
        input_label_registry: "",
        inpt_label_group: "",
        quick_value: "",
      },
      fields: [
        {
          key: "selezionato",
          label: "",
          sortable: false,
          // thClass viene sovrascritto da CustomFieldsAndActionsMixin: senza .check sul th
          // la regola globale table th:not([aria-sort]):not(.check) blocca i click sulla checkbox
          class: "check",
          thStyle: {
            width: "2px",
          },
        },
        {
          key: "rowSelector",
          label: "Incassa",
          sortable: false,
          thStyle: {
            width: "20px",
          },
        },
        {
          key: "effective_at",
          label: this.getDictionary("effective_at", "insurance_ancillary"),
          sortable: true,
          sortKey: "byAttribute.effective_at",
          formatter: (value) => toLocaleDate(value),
          thStyle: {
            width: "80px",
          },
        },
        {
          key: "delay_until",
          formatter: (value) => toLocaleDate(value),
          sortable: true,
          label: this.getDictionary("delay_until", "insurance_ancillary"),
        },
        {
          key: "insurance_policy_insurer",
          label: this.getDictionary(
            "insurance_policy_id",
            "insurance_ancillary",
          ),
          sortable: true,
          sortKey: "byInsurancePolicy.number",
        },
        {
          key: "cooperators",
          label: this.getDictionary("cooperators", "insurance_ancillary"),
        },
        {
          key: "code.value",
          label: this.getDictionary("code", "insurance_ancillary"),
          sortKey: "code",
          sortable: true,
        },
        {
          key: "insurance_policy.insurance_risk.risk_branch.formatted_title",
          label: this.getDictionary("title", "risk_branch"),
          sortable: true,
          sortKey: "byRiskBranch.title",
        },
        {
          key: "insurance_policy_title",
          label: this.getDictionary("Descrizione Polizza"),
          sortable: true,
          sortKey: "byInsurancePolicy.title",
        },
        {
          key: "customer",
          label: this.getDictionary("contractor"),
          sortable: true,
          sortKey: "byRegistry.title",
        },
        {
          key: "address_book",
          label: this.getDictionary("address_book"),
          sortable: false,
        },
        {
          key: "primary_group",
          label: this.getDictionary("primary_group"),
          sortable: true,
          sortKey: "byRegistryGroup.code",
        },
        {
          key: "gross",
          label: this.getDictionary("gross", "insurance_ancillary"),
          formatter: (value) => toLocaleCurrency(value),
          sortable: true,
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        {
          key: "status_ancillary.text",
          label: this.getDictionary("status_ancillary", "insurance_ancillary"),
          sortable: true,
          sortKey: "status_ancillary",
        },
        {
          key: "delay_days",
          label: this.getDictionary("delay_days", "insurance_ancillary"),
          sortable: false,
        },
        {
          key: "broker",
          label: this.getDictionary("broker_id", "insurance_ancillary"),
          sortable: true,
          sortKey: "byBroker.BUID",
        },
        {
          key: "insurance_payments",
          label: "Commento QT",
          sortable: false,
          formatter: (value) => this.retrieveComment(value),
        },
        {
          key: "note_counter",
          label: this.getDictionary("Note"),
          sortable: false,
        },
      ],
      salesmen: [],
      salesmen_taggable: true,
      cooperators: [],
      myTogglePO: false,
      myToggle: false,
      salesmen_ids: [],
      salesmen_ordered: [],
      salesmen_select: [],
      titoli: [
        { value: "0", text: "Da incassare" },
        { value: "1", text: "Incassato" },
        { value: "2", text: "Stornati" },
        { value: "3", text: "Annullati manualmente" },
        { value: "4", text: "Annullati manualmente + annullo polizza" },
        { value: "5", text: "Annullati su piattaforma compagnia" },
        { value: "6", text: "Annullati per sostituzione" },
        { value: "7", text: "Da validare" },
      ],
      tipo_titoli: [
        { value: "P", text: "Polizze" },
        { value: "Q", text: "Quietanze" },
        { value: "A", text: "Appendici" },
        { value: "X", text: "Altro" },
      ],
      upselling_options: [
        { value: "Y", text: "Sì" },
        { value: "N", text: "No" },
      ],
      opt_status: [
        { value: "expired", text: "Scaduti" },
        { value: "last_day", text: "Ultimo giorno di mora" },
        { value: "ending", text: "In scadenza" },
        { value: "valid", text: "Validi" },
      ],
      // isCollapseOpen: true,
    };
  },
  components: {
    BaseIcon,
    BaseInput,
    // ButtonGroupTable,
    ExportOptions,
    BaseSelect,
    BaseDatepicker,
    InsuranceAncillaries,
    QuickSearchGroupModal,
    RecuperaDaSyncroModal,
  },
  methods: {
    toInfoData,
    forcedFetch(policy_number) {
      // if (this.isCollapseOpen === true) {
      //   this.$root.$emit("bv::toggle::collapse", "insAncCollapse");
      // }
      if (policy_number) {
        this.onClearFilter(this.filterName);
        this.filter.byInsurancePolicy.number = policy_number;
      }
      // this.$root.$emit("bv::hide::collapse", "insAncCollapse");
      this.onSearch(this.filterName);
    },
    customOpenSyncroModal(target) {
      console.log("target", target);
      this.$bvModal.show("recuperaDaSyncroModal");
    },
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    selectAllSalesmen() {
      this.filter.byBroker.id = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
    },
    deselectAllSalesmen() {
      this.filter.byBroker.id = [];
      this.salesman_id = null;
    },
    retrieveComment(value) {
      return value?.[0]?.comment ? value[0].comment : "-";
    },
    setYearRange(offset = 0) {
      const year = moment().add(offset, "year");
      this.filter.byCalendar.from = year
        .clone()
        .startOf("year")
        .format("YYYY-MM-DD");
      this.filter.byCalendar.to = year
        .clone()
        .endOf("year")
        .format("YYYY-MM-DD");
    },
    getYearLabel(offset = 0) {
      return moment().add(offset, "year").format("YYYY");
    },
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    onRegistryTitleInput() {
      this.filter.byRegistry.id = null;
    },
    initFilter() {
      let init = {
        byAttribute: {
          status_ancillary: "0",
          delay_days: null,
          title: null,
          code: ["P", "Q", "A"],
          upselling: null,
          to_collect: null,
          consolidated: null,
        },
        byBroker: {
          id: null,
        },
        byCollaborator: {
          id: null,
        },
        byRegistry: {
          id: null,
          title: null,
          null: null,
        },
        byRiskType: {
          id: null,
        },
        byRegistryGroup: {
          code: null,
        },
        byInsurer: {
          id: null,
        },
        byInsurancePolicy: {
          id: null,
          number: null,
          status_policy: null,
        },
        byInsurancePayment: {
          comment: null,
        },
        byStocastico: {
          date: moment().format("YYYY-MM-DD"),
          status: [],
        },
        byCalendar: {
          from: null,
          to: null,
        },
        byDelayUntil: {
          from: null,
          to: null,
        },
      };
      return init;
    },
    onAddBookEntry(row) {
      this.resetPolicyId();
      this.resetRegistryId();
      this.resetGroupId();
      this.removeQuickSearchByName(this.filterName);
      this.$router.push({
        name: `book_entries.create`,
        params: {
          mode: "IV",
          titleId: row.id,
          insuranceRiskId: row.insurance_risk_id,
        },
      });
    },
    onAdd() {
      this.$router.push({ name: `${this.resource}.create` });
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onEdit(id) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: { id: `${id}` },
      });
    },
    onDestroy(id) {
      // console.debug("DESTROYING id:", id);
      if (this.deletingIds.includes(id)) return;
      this.deletingIds.push(id);
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          // console.debug("successfully deleted!");
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Titolo eliminato con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.deletingIds = this.deletingIds.filter((did) => did !== id);
        });
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      // console.log(name, "test");
      let criteria = this.filter;
      // story-681
      // if (!this.filter.byAttribute.code.length) {
      //   this.filter.byAttribute.code = "!X";
      // }
      // console.log("Filter: ", this.filter);
      this.saveFilterByName({ name, criteria });
      let extra_info = this.extra_group_full_info;
      this.saveFilterExtraGroupByName({ name, extra_info });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      // console.log(this.$refs[this.tableRef]);
      // this.$refs[this.tableRef].fetch();
      // TODO
      // Trovare il punto dove viene eliminato il filter al cambio modulo e aggiungerci l'eliminazione del quicksearch
      // quicksearch
      criteria = {};

      ["quickSearchPolicy", "quickSearchRegistry", "quickSearchGroup"].forEach(
        (element) => {
          criteria[element] = {
            label: "",
            formLabel: "",
            data: null,
            formData: null,
          };
        },
      );
      criteria.quickSearchPolicy.label = this.filter.byInsurancePolicy.number;
      criteria.quickSearchPolicy.formLabel = "filter.byInsurancePolicy.number";
      criteria.quickSearchPolicy.data = this.insurance_policy_data;
      criteria.quickSearchPolicy.formData = "insurance_policy_data";
      criteria.quickSearchRegistry.label = this.form.input_label_registry;
      criteria.quickSearchRegistry.formLabel = "form.input_label_registry";
      criteria.quickSearchRegistry.data = this.registry_data;
      criteria.quickSearchRegistry.formData = "registry_data";
      criteria.quickSearchGroup.label = this.form.inpt_label_group;
      criteria.quickSearchGroup.formLabel = "form.inpt_label_group";
      criteria.quickSearchGroup.data = this.group_data;
      criteria.quickSearchGroup.formData = "group_data";
      this.saveQuickSearchByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      // REVIEW
      // NOTE
      // per tutte le index con quickSearch
      // finché non si trova il modo di "fillare" anche i dati delle quicksearch memorizzati nel criteria,
      // non è possibile consentire alla index di far autofecth, poichè non si vede nelle quicksearch che viene applicato
      // anche quel filtro!!! perciò, eliminiamo subito il filtro.
      // this.$refs[this.tableRef].fetch().then(() => {
      //   this.removeFilterByName(name);
      //   this.removeQuickSearchByName(name);
      // });
      this.$refs[this.tableRef].fetch().then(() => {
        // story-681
        // if (this.filter.byAttribute.code === "!X") {
        //   this.filter.byAttribute.code = [];
        // }
      });
    },
    onClearFilter(name) {
      this.resetPolicyId();
      this.resetRegistryId();
      this.resetGroupId();
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removeQuickSearchByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "delay_until";
      this.$refs[this.tableRef].sortDesc = false;
      // this.onSearch(name);
    },
    handleRegistryModalInput(value) {
      this.filter.byRegistry.id = value.id;
      this.registry_data = value;
      this.form.input_label_registry = this.toInfoData(
        this.registry_data,
        "registryfullname",
      );
      this.$bvModal.hide("quickSearchRegistryModal");
    },
    openQuickSearchRegistry() {
      this.filter.byRegistry.id = null;
      this.$bvModal.show("quickSearchRegistryModal");
    },
    resetRegistryId() {
      this.registry_data = null;
      this.form.input_label_registry = null;
      this.filter.byRegistry.id = null;
      this.filter.byRegistry.title = null;
    },
    handlePolicyModalInput(value) {
      this.form.quick_value = value.id;
      this.filter.byInsurancePolicy.id = value.id;
      this.form.inpt_label_policy = value.number;
      this.insurance_policy_data = value;
      this.$bvModal.hide("quickSearchPolicyModal");
    },
    openQuickSearchPolicy() {
      this.form.quick_value = null;
      this.$bvModal.show("quickSearchPolicyModal");
    },
    resetPolicyId() {
      this.insurance_policy_data = null;
      this.form.inpt_label_policy = null;
      this.filter.byInsurancePolicy.id = null;
    },
    handleGroupModalInput(value) {
      this.filter.byRegistryGroup.code = value.code;
      this.group_data = value;
      this.form.inpt_label_group = this.toInfoData(
        this.group_data,
        "registry_group",
      );
      this.extra_group_full_info = this.toInfoData(
        this.group_data,
        "registry_group_full",
        null,
        "",
      );
      this.$bvModal.hide("quickSearchGroupModal");
    },
    openQuickSearchGroup() {
      this.filter.byRegistryGroup.code = null;
      this.$bvModal.show("quickSearchGroupModal");
    },
    resetGroupId() {
      this.group_data = null;
      this.form.inpt_label_group = null;
      this.filter.byRegistryGroup.code = null;
      this.extra_group_full_info = null;
    },
    onSelectAll() {
      this.filterUpdate("spunta");
    },
    onUnselectAll() {
      this.uncheckSelected();
    },
    /*
     * Spunta/toglie la spunta ai soli titoli della pagina corrente: a differenza di
     * "Spunta tutte" non usa il filtro della ricerca ma gli id delle righe caricate, e non
     * ricarica la tabella così l'utente resta sulla pagina in cui si trova.
     */
    onSelectPage(selected) {
      let tableRef = this.$refs[this.tableRef];
      const items = tableRef.pageSelectableItems.filter(
        (item) => item.selected.value !== selected,
      );
      if (!items.length) return;
      let queryString = `byAttribute[id]=${items
        .map((item) => item.id)
        .join(",")}`;
      let payload = {
        related: {
          users: {
            [this.userId]: {
              selected: selected,
            },
          },
        },
      };
      this.isLoadingSpunte = true;
      let Repo = RepositoryFactory.get(this.repository);
      Repo.filter_update(payload, queryString)
        .then(() => {
          items.forEach((item) => {
            item.selected.value = selected;
            item.selected.text = selected === "Y" ? "Si" : "No";
            // calculateItemSelected() ricava la spunta da users a ogni render
            item.users = selected === "Y" ? [{ id: this.userId }] : [];
          });
          return tableRef.loadSelectedCounter();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: `${errMsg}` });
        })
        .finally(() => {
          this.isLoadingSpunte = false;
        });
    },
    uncheckSelected() {
      let tableRef = this.$refs[this.tableRef];
      let Repo = RepositoryFactory.get(this.repository);
      Repo.uncheck_selected()
        .then(() => {
          tableRef.loadSelectedCounter();
          this.$showSnackbar({
            preset: "success",
            text: `Spunte tolte con successo`,
          });
          this.onSearch(this.filterName);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: `${errMsg}` });
        });
    },
    filterUpdate(mode) {
      this.isLoadingSpunte = true;
      let filter;
      let queryString;
      let qs = {};
      let payload = {
        related: {
          users: {
            [this.userId]: {
              selected: null,
            },
          },
        },
      };
      let tableRef = this.$refs[this.tableRef];
      const rgx = /(byAttribute\[status_ancillary\]=.{1})/;
      switch (mode) {
        case "spunta":
          payload.related = { users: { [this.userId]: { selected: "Y" } } };
          filter = tableRef.loadFilter(tableRef.filterName);
          if (filter) {
            qs.filter = filter;
            if (qs.filter.indexOf("byAttribute[status_ancillary]") >= 0) {
              qs.filter = qs.filter.replace(
                rgx,
                "byAttribute[status_ancillary]=0",
              );
            } else {
              qs.filter += "&byAttribute[status_ancillary]=0";
            }
            queryString = Object.values(qs).join("&");
          } else {
            let criteria = this.filter;
            queryString = prepareFilterQueryString(criteria);
            queryString += "byAttribute[status_ancillary]=0";
          }
          break;
        default:
          break;
      }
      let Repo = RepositoryFactory.get(this.repository);
      this.isLoading = true;
      this.isLoadingSpunte = true;
      Repo.filter_update(payload, queryString)
        .then(() => {
          tableRef.loadSelectedCounter();
          tableRef.items.forEach((item) => {
            if (item.selected)
              item.selected.value = payload.related.users[this.userId].selected;
          });
          this.isLoading = false;
          this.isLoadingSpunte = true;
          this.$showSnackbar({
            preset: "success",
            text: `Spunte aggiunte con successo`,
          });
          this.onSearch(this.filterName);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: `${errMsg}` });
        })
        .finally(() => {
          this.isLoading = false;
          this.isLoadingSpunte = false;
        });
    },
    onUpdateSelected(row, checkboxElement) {
      let queryString = `byAttribute[id]=${row.id}`;
      let payload = {
        related: {
          users: {
            [this.userId]: {
              selected: row.selected.value,
            },
          },
        },
      };
      let tableRef = this.$refs[this.tableRef];
      let Repo = RepositoryFactory.get(this.repository);
      Repo.filter_update(payload, queryString)
        .then(() => {
          // calculateItemSelected() ricava la spunta da users a ogni render, e intanto
          // può aver già riportato row.selected al valore precedente: si usa quello inviato
          row.users =
            payload.related.users[this.userId].selected === "Y"
              ? [{ id: this.userId }]
              : [];
          tableRef.loadSelectedCounter();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: `${errMsg}` });
        })
        .finally(() => {
          if (checkboxElement && checkboxElement.previousElementSibling) {
            checkboxElement.previousElementSibling.classList.add("hide-it");
            checkboxElement.classList.remove("hide-it");
          }
        });
    },
    /* Nessuna conferma: il toggle è reversibile finché il titolo non è consolidato */
    onToggleToCollect(row) {
      let tableRef = this.$refs[this.tableRef];
      let Repo = RepositoryFactory.get(this.repository);
      const wasToCollect = row.to_collect.value === "Y";
      const value = wasToCollect ? "N" : "Y";
      Repo.to_collect_update(row.id, { to_collect: value })
        .then(() => {
          /* Aggiorna la riga in locale, senza rifare la fetch */
          let item = tableRef.items.find((item) => item.id == row.id);
          item.to_collect.value = value;
          item.to_collect.text = wasToCollect ? "No" : "Sì";
          this.$showSnackbar({
            preset: "success",
            text: `Titolo reso ${
              wasToCollect ? "non incassabile" : "incassabile"
            }`,
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: `${errMsg}` });
        });
    },
    onSendCommunications() {
      this.saveLisacomunicaAutoModal(true);
      this.saveLisacomunicaFromAncillaries(true);
      this.$router.push({ name: "communication_procedures.index" });
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      saveFilterExtraGroupByName: "saveExtraGroupByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("quicksearch", {
      saveQuickSearchByName: "saveByName",
      removeQuickSearchByName: "removeByName",
    }),
    ...mapActions("lisacomunica_automodal", [
      "saveLisacomunicaAutoModal",
      "saveLisacomunicaFromAncillaries",
    ]),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    ...mapGetters("auth", {
      getInsurers: "insurers",
      getSalesmen: "salesmen",
      getCooperators: "cooperators",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
      getRisks: "risks",
    }),
  },
  computed: {
    computePerformedSearch() {
      return this.performedSearch;
    },
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    agencyHasFee() {
      return this.$store.state.auth.use_fee === "Y" ? true : false;
    },
  },
  beforeMount() {
    this.salesmen = this.getSalesmen();
    this.salesmen_select = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
    //   // #1153 se non c'è già un filtro salvato, imposto i valori di default
    //   let found = this.loadFilter(this.filterName);
    //   if (!found) {
    //     this.$set(this, "filter", this.initFilter());
    //   } else {
    //     this.$set(this, "filter", found);
    //   }
  },
  mounted() {
    this.companies = this.getInsurers();
    this.salesmen = this.getSalesmen();
    this.risks = this.getRisks();
    // this.onCollapseState = (collapseId, isJustShown) => {
    //   if (collapseId === "insAncCollapse") {
    //     this.isCollapseOpen = isJustShown;
    //   }
    // };
    // this.$root.$on("bv::collapse::state", this.onCollapseState);
    this.open_filter = this.areActiveFiltersOnlyDefault();
  },
  // beforeDestroy() {
  //   this.$root.$off("bv::collapse::state", this.onCollapseState);
  // },
  created() {
    if (this.agencyHasFee) {
      const feeGrossField = {
        key: "fee_gross",
        label: this.getDictionary("fee_gross", "insurance_ancillary"),
        formatter: (value) => toLocaleCurrency(value),
        sortable: true,
        thClass: "text-right",
        thStyle: {
          "text-align": "right",
        },
        tdClass: "text-right",
      };
      this.fields.splice(11, 0, feeGrossField);
    }
    /* */
    const path = "auth/";
    const resources = [];
    /* Background resource preloading for councils, provinces, countries */
    if (!this.hasLoadedResource("councils"))
      resources.push(
        this.$store
          .dispatch(`${path}councils`)
          .then(() => {
            console.info(`background data "${path}councils" fetched correctly`);
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (!this.hasLoadedResource("provinces"))
      resources.push(
        this.$store
          .dispatch(`${path}provinces`)
          .then(() => {
            console.info(
              `background data "${path}provinces" fetched correctly`,
            );
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (!this.hasLoadedResource("countries")) {
      resources.push(
        this.$store
          .dispatch(`${path}countries`)
          .then(() => {
            console.info(
              `background data "${path}countries" fetched correctly`,
            );
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    }
    if (!this.hasLoadedResource("cooperators")) {
      resources.push(
        this.$store
          .dispatch(`${path}cooperators`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    } else {
      this.cooperators = this.getCooperators();
    }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          this.cooperators = this.getCooperators();
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
  },
  // beforeDestroy() {
  //   this.onClearFilter(this.filterName);
  // },
};
</script>

<style lang="scss" scoped>
// Legenda dei colori delle righe, nella riga della paginazione accanto a
// "Risultati da … a …".
.ancillary-legend {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-left: 8px;
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
  white-space: nowrap;
}

.ancillary-legend__item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.ancillary-legend__dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;

  &.is-ending {
    background: #fff8bb;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);
  }

  &.is-last-day {
    background: #ffa91f;
  }

  &.is-expired {
    background: #ffdddd;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);
  }
}
</style>
